import { InputAdornment } from "@mui/material";
import { MRNInputField } from "../AddPatientGroup.style";
import { IconSearch } from "../../common/SearchBox.style";

type InputMRNProps = {
  mrn: string;
  onChange: (value: string) => void;
  onEnterPress?: () => void;
};
export const InputMRN = ({ mrn, onChange, onEnterPress }: InputMRNProps) => {
  return (
    <MRNInputField
      size="small"
      placeholder="MRN"
      id="mrn"
      type="text"
      variant="outlined"
      onChange={e => {
        const mrn: string = e.target.value;
        onChange(mrn);
      }}
      onKeyDown={e => {
        if (e.key === "Enter" && onEnterPress) {
          onEnterPress();
        }
      }}
      value={mrn}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <IconSearch fontSize={"small"} />
            </InputAdornment>
          ),
        },
        inputLabel: { shrink: !!mrn },
        htmlInput: { "data-testid": "mrn", maxLength: 25 },
      }}
    />
  );
};
